<template>
  <d2-container>
    <top-line :message="pageTitle" :iconclass="'fa fa-file-text-o'"></top-line>
    <el-row class="pagebody">
      <el-row class="filter-bar">
        <el-card shadow="never">
          <el-form :inline="true" :model="searchForm" ref="searchForm" label-width="200px" size="small">
            <el-row >
              <el-col :span="20">
                <el-form-item label="用户：" prop="userName" class="search-item" :label-width="labelWidth">
                  <el-input v-model="searchForm.userName" style="width:175px" />
                </el-form-item>
                <el-form-item label="产品：" prop="productName" class="search-item" :label-width="labelWidth">
                  <el-input v-model="searchForm.productName" style="width:175px" />
                </el-form-item>
                <el-form-item label="状态:" prop="status" class="search-item" :label-width="labelWidth">
                  <el-select v-model="searchForm.status" placeholder="请选择状态" style="width: 175px">
                    <el-option label="全部状态" value=""></el-option>
                    <el-option label="用户取消" value="0"></el-option>
                    <el-option label="待销售确认" value="1"></el-option>
                    <el-option label="待交付" value="2"></el-option>
                    <el-option label="放弃" value="3"></el-option>
                    <el-option label="已交付" value="4"></el-option>
                    <el-option label="已完成" value="5"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="4">
                <el-button type="primary" icon="el-icon-search" size="small" plain style="margin-left:8px;"
                           class="fr"
                           @click="handleSearch">
                  查询
                </el-button>
                <el-button type="info" icon="el-icon-refresh-left" size="small" plain style="margin-left:8px;"
                           class="fr"
                           @click="handleReset">
                  重置
                </el-button>
              </el-col>

            </el-row>
          </el-form>
        </el-card>
      </el-row>

      <el-row class="main-table">
          <el-table
            :data="tableData"
            border
            stripe
            style="width: 100%"
          >
            <!-- 资源请求ID -->
            <!-- <el-table-column fixed prop="id"  label="ID" width="80" />-->
            <!-- 创建时间 -->
            <el-table-column label="提交时间"  align="center">
              <template v-slot="scope">
                <el-tooltip class="item" effect="dark" content="点击查看详情" placement="bottom-start">
                  <el-button type="text" @click="showDetails(scope.row)">{{ formatDateTime(scope.row.created_at) }}</el-button>
                </el-tooltip>
              </template>
            </el-table-column>
            <!-- 状态 -->
            <el-table-column prop="status" label="状态" align="center" width="120">
              <template v-slot="scope">
                <el-tag :type="getStatusFormat(scope.row.status)">
                  {{ formatQuestStatusText(scope.row.status) }}
                </el-tag>
              </template>
            </el-table-column>
            <!-- 用户名称 -->
            <el-table-column label="用户" width="150" align="center">
              <template v-slot="scope">
                <el-tooltip class="item" effect="dark" content="点击查看详情" placement="bottom-start">
                  <el-button type="text" @click="showDetails(scope.row)">{{ scope.row.user_name }}</el-button>
                </el-tooltip>
              </template>
            </el-table-column>
            <!-- 可用区 -->
            <el-table-column prop="region" label="可用区" width="150" align="center" show-overflow-tooltip />
            <!-- 产品名称 -->
            <el-table-column prop="product_name" label="产品" width="150" show-overflow-tooltip />
            <!-- 产品类型 -->
            <el-table-column prop="type_name" label="类型" width="80" align="center" show-overflow-tooltip />
            <!-- 请求数量 -->
            <el-table-column prop="quantity" label="请求数量" width="80" align="center"/>
            <!-- 剩余主机数量 -->
            <el-table-column prop="remaining_hosts" label="剩余数量" width="80" align="center"/>
            <!-- 开始日期 -->
            <el-table-column label="起租日期"  align="center">
              <template v-slot="scope">
                {{ formatDate(scope.row.start_date) }}
              </template>
            </el-table-column>
            <!-- 结束日期 -->
            <el-table-column label="结束日期"  align="center">
              <template v-slot="scope">
                {{ formatDate(scope.row.end_date) }}
              </template>
            </el-table-column>
            <!-- 价格 -->
            <el-table-column prop="price" label="价格" width="120" align="right">
              <template v-slot="scope">
                <div>
                  {{ scope.row.price }}
                  <span class="price-unit">{{ priceUnitLabelMap(scope.row.price_unit) }}</span>
                </div>
              </template>
            </el-table-column>
            <!-- 操作列 -->
            <el-table-column fixed="right" header-align="center" width="130" align="center" show-overflow-tooltip label="操作">
              <template v-slot="scope">
                <el-button plain
                  type="danger"
                  v-if="scope.row.status === 1"
                  size="mini"
                  @click="showSalesConfirmation(scope.row)">销售确认</el-button>
                <el-button plain
                  type="success"
                  v-if="[2, 3, 4, 5].includes(scope.row.status)"
                  size="mini"
                  @click="orderManagement(scope.row)">订单管理</el-button>
              </template>
            </el-table-column>
          </el-table>
      </el-row>
      <el-row type="flex" justify="left" style="margin-top: 10px; margin-bottom: 18px;">
        <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page.sync="pagination.page"
            :page-sizes="pagination.pageSizeList"
            :page-size="pagination.pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="pagination.total">
        </el-pagination>
      </el-row>
    </el-row>

    <!-- 销售确认对话框 -->
    <el-dialog
      title="销售确认"
      :visible.sync="salesConfirmVisible"
      width="500px"
      @close="resetSalesForm">
      <el-form :model="salesForm" ref="salesForm" label-width="100px">
        <el-form-item label="用户名称">
          <el-input v-model="salesForm.user_name" disabled />
        </el-form-item>
        <el-form-item label="产品名称">
          <el-input v-model="salesForm.product_name" disabled />
        </el-form-item>
        <el-form-item label="数量">
          <el-input v-model="salesForm.quantity" disabled />
        </el-form-item>
        <el-form-item label="操作" required>
          <el-radio-group v-model="salesForm.action">
            <el-radio label="accept">确认接受</el-radio>
            <el-radio label="abandon">拒绝</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="备注信息">
          <el-input type="textarea" v-model="salesForm.remark" rows="3" />
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="salesConfirmVisible = false">取消</el-button>
        <el-button type="primary" @click="confirmSalesAction">确定</el-button>
      </span>
    </el-dialog>

    <!-- 订单管理抽屉 -->
    <el-drawer
      title="订单管理"
      :visible.sync="orderDrawerVisible"
      size="50%"
      style="font-size: 16px; font-weight: bold;"
      direction="rtl">
      <!-- 按钮栏 -->
      <div class="order-buttons-bar" v-if="currentOrder.status !== 5">
        <el-button v-if="!currentOrder.id" type="primary" @click="handleCreateOrder">创建订单</el-button>
        <el-button v-if="currentOrder.id" type="success" @click="handleOrderDelivery">交付管理</el-button>
        <el-button v-if="currentOrder.id" type="warning" @click="handleOrderRecycle">回收管理</el-button>
      </div>

      <!-- 无关联订单状态 -->
      <div v-if="!currentOrder.id" class="no-order-state">
        <div class="no-order-icon">
          <i class="el-icon-document"></i>
        </div>
        <div class="no-order-text">暂无关联数据</div>
      </div>

      <!-- 订单详情状态 -->
      <div v-else class="order-detail-state">
        <el-card shadow="never" class="detail-card">
          <div slot="header" class="clearfix">
            <span style="font-size: 16px;">订单详情</span>
          </div>

          <el-row :gutter="20">
            <el-col :span="12">
              <div class="detail-item">
                <span class="detail-label">订单名称：</span>
                <span class="detail-value">{{ currentOrder.order_no }}</span>
              </div>
            </el-col>
            <el-col :span="12">
              <div class="detail-item">
                <span class="detail-label">客户名称：</span>
                <span class="detail-value">{{ currentOrder.customer_name }}</span>
              </div>
            </el-col>
          </el-row>

          <el-row :gutter="20" style="margin-top: 15px;">
            <el-col :span="12">
              <div class="detail-item">
                <span class="detail-label">资源类型：</span>
                <span class="detail-value">{{ currentOrder.resource_type }}</span>
              </div>
            </el-col>
            <el-col :span="12">
              <div class="detail-item">
                <span class="detail-label">订单类型：</span>
                <span class="detail-value">{{ formatOrderType(currentOrder.order_type) }}</span>
              </div>
            </el-col>
          </el-row>

          <el-row :gutter="20" style="margin-top: 15px;">
            <el-col :span="12">
              <div class="detail-item">
                <span class="detail-label">可用区：</span>
                <span class="detail-value">{{ currentOrder.region || '-' }}</span>
              </div>
            </el-col>
          </el-row>

          <el-row :gutter="20" style="margin-top: 15px;">
            <el-col :span="12">
              <div class="detail-item">
                <span class="detail-label">账单日：</span>
                <span class="detail-value">{{ currentOrder.billing_day }} 号</span>
              </div>
            </el-col>
            <el-col :span="12">
              <div class="detail-item">
                <span class="detail-label">订单状态：</span>
                <span class="detail-value">{{ formatOrderStatus(currentOrder.status) }}</span>
              </div>
            </el-col>
          </el-row>

          <el-row :gutter="20" style="margin-top: 15px;">
            <el-col :span="12">
              <div class="detail-item">
                <span class="detail-label">货币类型：</span>
                <span class="detail-value">{{ currentOrder.currency }}</span>
              </div>
            </el-col>
            <el-col :span="12">
              <div class="detail-item">
                <span class="detail-label">总价：</span>
                <span class="detail-value">{{ currentOrder.total_price }}</span>
              </div>
            </el-col>
          </el-row>

          <el-row :gutter="20" style="margin-top: 15px;">
            <el-col :span="12">
              <div class="detail-item">
                <span class="detail-label">设备数量：</span>
                <span class="detail-value">{{ currentOrder.dev_number }}</span>
              </div>
            </el-col>
            <el-col :span="12">
              <div class="detail-item">
                <span class="detail-label">已交付数量：</span>
                <span class="detail-value">{{ currentOrder.delivered_number }}</span>
              </div>
            </el-col>
          </el-row>
          <el-row :gutter="20" style="margin-top: 15px;">
            <el-col :span="12">
              <div class="detail-item">
                <span class="detail-label">订单起始时间：</span>
                <span class="detail-value">{{ currentOrder.starting_time }}</span>
              </div>
            </el-col>
            <el-col :span="12">
              <div class="detail-item">
                <span class="detail-label">订单结束时间：</span>
                <span class="detail-value">{{ currentOrder.end_time }}</span>
              </div>
            </el-col>
          </el-row>

          <!-- 价格明细列表 -->
          <el-row style="margin-top: 30px;">
            <el-col :span="24">
              <div class="detail-title">
                <h3>价格明细：</h3>
              </div>
              <el-table
                :data="currentOrder.price_items || []"
                border
                style="width: 100%; margin-top: 10px;"
                :default-sort="{ prop: 'name', order: 'ascending' }"
              >
                <el-table-column type="index" label="序号" width="60" align="center"></el-table-column>
                <el-table-column prop="name" label="收费项目名称" min-width="110" sortable></el-table-column>
                <el-table-column prop="specifications" label="规格" min-width="90"></el-table-column>
                <el-table-column prop="dev_character" label="资源类型" min-width="90"></el-table-column>

                <!-- 单位：根据 dev_character 动态映射 -->
                <el-table-column label="单位" width="60">
                  <template slot-scope="scope">
                    {{ getMeteringUnitLabel(scope.row) }}
                  </template>
                </el-table-column>

                <!-- 直接展示后端返回的单价 -->
                <el-table-column prop="unit_price" label="单价(元)" min-width="60">
                  <template slot-scope="scope">
                    {{ scope.row.unit_price  }}
                  </template>
                </el-table-column>
                <!-- 状态：下拉选择启用/禁用 -->
                <el-table-column label="状态">
                  <template slot-scope="scope">
                    <span :class="scope.row.status === 1 ? 'status-enabled' : 'status-disabled'">
                      {{ formatStatusText(scope.row.status) }}
                    </span>
                  </template>
                </el-table-column>

                <!-- 备注 -->
                <el-table-column prop="remark" label="备注" min-width="150" show-overflow-tooltip></el-table-column>
              </el-table>
            </el-col>
          </el-row>
        </el-card>
      </div>
    </el-drawer>

    <!-- 新增订单组件 -->
    <CreateOrder ref="createOrder" :resourceId="currentRequestForOrder && currentRequestForOrder.id" :productId="currentRequestForOrder && currentRequestForOrder.product_id" :resourceRequest="currentRequestForOrder" :region="currentRequestForOrder && currentRequestForOrder.region" @success="handleOrderSuccess"></CreateOrder>
  </d2-container>
</template>
<script>
import topLine from "@/components/save-common/topLine.vue";
import CreateOrder from './CreateOrder.vue';
import { MessageBox } from 'element-ui';
import { priceUnitLabelMap, getStatusFormat, formatQuestStatusText } from '@/utils/dataproc'

export default {
  name: "resourceRequests",
  components: {
    topLine,
    CreateOrder,
  },
  mounted () {
    this.loadParams();
    this.getTableData();
  },
  data() {
    return {
      pageTitle: "资源请求",
      labelWidth: '120px',
      tableDataApi: '/api-30216/api/resource-requests',
      searchForm: {
        userName: '',
        productName: '',
        status: '',
        page: parseInt(this.$route.query.page) || 1,
        pageSize: parseInt(this.$route.query.pageSize) || 10,
      },
      pagination: {
        page: parseInt(this.$route.query.page) || 1,
        pageSize: parseInt(this.$route.query.pageSize) || 10,
        pageSizeList: [10, 20, 50, 100],
        total: 0,
      },
      tableData: [],
      salesConfirmVisible: false,
      currentRequest: null,
      salesForm: {
        user_name: '',
        product_name: '',
        quantity: '',
        action: 'accept',
        remark: ''
      },
      // 订单管理相关
      orderDrawerVisible: false,
      currentRequestForOrder: null,
      currentOrder: {
        id: '',
        order_no: '',
        customer_name: '',
        resource_type: '',
        order_type: '',
        billing_day: '',
        status: '',
        total_price: '',
        currency: '',
        dev_number: '',
        delivered_number: '',
        starting_time: '',
        end_time: '',
        region: '',
        price_items: []
      }
    }
  },
  methods: {
    getStatusFormat,
    priceUnitLabelMap,
    formatQuestStatusText,

    // 格式化日期时间
    formatDate(datetime) {
      if (!datetime) return '';
      const date = new Date(datetime);
      if (isNaN(date.getTime())) return '';
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const day = String(date.getDate()).padStart(2, '0');
      return `${year}-${month}-${day}`;
    },

    formatDateTime(datetime) {
      if (!datetime) return '';
      const date = new Date(datetime);
      if (isNaN(date.getTime())) return '';
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const day = String(date.getDate()).padStart(2, '0');
      const hours = String(date.getHours()).padStart(2, '0');
      const minutes = String(date.getMinutes()).padStart(2, '0');
      const seconds = String(date.getSeconds()).padStart(2, '0');
      return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
    },

    loadParams() {
      if(this.$route.query.page) {
        this.pagination.page = parseInt(this.$route.query.page, 10);
      }
      if(this.$route.query.pageSize) {
        this.pagination.pageSize = parseInt(this.$route.query.pageSize, 10);
      }
    },
    handleReset() {
      this.searchForm = {
        userName: '',
        productName: '',
        status: '',
        page: 1,
        pageSize: 10,
      };
      this.getTableData();
    },
    //查询
    handleSearch() {
      this.pagination.page = 1;
      this.getTableData();
    },
    handleSizeChange(size) {
      this.pagination.pageSize = size;
      this.getTableData();
    },
    handleCurrentChange(page) {
      this.pagination.page = page;
      this.getTableData();
    },

    getTableData() {
      this.$axios.get(this.tableDataApi, {
      params: {
        userName: this.searchForm.userName,
        productName: this.searchForm.productName,
        status: this.searchForm.status,
        page: this.pagination.page,
        pageSize: this.pagination.pageSize,
      }
      }).then(response => {
        console.log(response);
        this.tableData = response.data || [];
        this.pagination.total = response.total || 0;
      });
    },

    // 用户信息详情
    showUserInfo(row) {

    },

    // 资源请求详情
    showDetails(row) {
      this.$router.push({
        path: '/api/resource-requests/details',
        query: {
          id: row.id,
          page: this.pagination.page,
          pageSize: this.pagination.pageSize
        }
      });
    },

    // 显示销售确认对话框
    showSalesConfirmation(row) {
      this.currentRequest = row;
      this.salesForm = {
        user_name: row.user_name,
        product_name: row.product_name,
        quantity: row.quantity,
        action: 'accept',
        remark: ''
      };
      this.salesConfirmVisible = true;
    },

    // 重置销售确认表单
    resetSalesForm() {
      this.salesForm = {
        user_name: '',
        product_name: '',
        quantity: '',
        action: 'accept',
        remark: ''
      };
      this.currentRequest = null;
    },

    // 确认销售操作
    confirmSalesAction() {
      if (this.salesForm.action === 'abandon') {
        MessageBox.confirm('确定要放弃此资源请求吗？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.submitSalesAction();
        }).catch(() => {
          // 用户取消
        });
      } else {
        this.submitSalesAction();
      }
    },

    // 提交销售操作
    submitSalesAction() {
      // 这里应该调用API更新资源请求状态
      const status = this.salesForm.action === 'accept' ? 2 : 3;
      this.$axios.put(`${this.tableDataApi}/${this.currentRequest.id}`, {
        status: status,
        approval_comments: this.salesForm.remark
      }, {
        headers: { 'Content-Type': 'application/json' },
        transformRequest: [postData => JSON.stringify(postData)]
      }).then(response => {
        if (response.code === 200) {
          this.$message.success('操作成功');
          this.salesConfirmVisible = false;
          this.getTableData();
        } else {
          this.$message.error(response.message || '操作失败');
        }
      }).catch(error => {
        console.error(error);
        this.$message.error('操作失败，请检查网络或服务状态');
      });
    },

    // 订单管理
    orderManagement(row) {
      this.currentRequestForOrder = row;
      // 重置订单信息
      this.currentOrder = {
        id: '',
        order_no: '',
        customer_name: '',
        resource_type: '',
        order_type: '',
        billing_day: '',
        status: '',
        total_price: '',
        currency: '',
        dev_number: '',
        delivered_number: '',
        starting_time: '',
        end_time: '',
        price_items: []
      };

      // 直接使用row.id作为订单ID，确保格式为UUID
      // 如果row.id不是UUID格式，可以根据实际情况调整
      const orderId = row.order_id ;
      this.getCurrentOrderInfo(orderId);

      this.orderDrawerVisible = true;
    },

    // 检查是否有关联订单
    checkAssociatedOrder(resourceId) {
      this.$axios.post('/api-30216/api/order-resources', {
        resource_id: resourceId
      }, {
        headers: { 'Content-Type': 'application/json' },
        transformRequest: [postData => JSON.stringify(postData)]
      }).then(response => {
        if (response.data && response.data.order_id) {
          // 有关联订单，获取订单详情
          this.getCurrentOrderInfo(response.data.order_id);
        } else {
          // 无关联订单，保持currentOrder为空
          this.currentOrder = {
            id: '',
            order_no: '',
            customer_name: '',
            resource_type: '',
            status: '',
            total_price: '',
            currency: ''
          };
        }
      }).catch(error => {
        console.error('检查关联订单失败:', error);
        // 出错时保持currentOrder为空
        this.currentOrder = {
          id: '',
          order_no: '',
          customer_name: '',
          resource_type: '',
          status: '',
          total_price: '',
          currency: ''
        };
      });
    },

    // 格式化订单状态
    formatOrderStatus(status) {
      const statusMap = {
        0: '草稿',
        1: '待审核',
        2: '生效中',
        3: '已终止',
        4: '已到期'
      };
      return statusMap[status] || '-';
    },

    // 格式化订单类型
    formatOrderType(value) {
      const map = {
        0: '开口',
        1: '闭口',
        2: '售前测试'
      };
      return map[value] || '-';
    },

    // 获取计量单位标签
    getMeteringUnitLabel(row) {
      const devCharacterUnitMap = {
        'GPU节点': '台·日',
        'CPU节点': '台·月',
        '存储': 'T·月',
        '容器云': '卡·时',
        '其他': '台·月'
      };

      const meteringUnitLabelMap = {
        '1': '台·日',
        '2': '卡·时',
        '3': 'T·月',
        '4': '台·月'
      };

      // 优先使用 dev_character
      if (row.dev_character && devCharacterUnitMap[row.dev_character]) {
        return devCharacterUnitMap[row.dev_character];
      }

      // 其次使用 metering_unit 编码
      if (row.metering_unit && meteringUnitLabelMap[row.metering_unit]) {
        return meteringUnitLabelMap[row.metering_unit];
      }

      // 最后 fallback
      return row.metering_unit || '—';
    },

    // 格式化状态文本
    formatStatusText(status) {
      const statusMap = {
        0: '禁用',
        1: '启用'
      };
      return statusMap[status] || '未知';
    },

    // 创建订单
    handleCreateOrder() {
      // 调用本地的 CreateOrder 组件
      this.$refs.createOrder.openDialog();
    },

    // 选择订单
    handleSelectOrder() {
      // 跳转到订单列表页面（合同管理），选择后返回
      this.$router.push({
        path: '/api/order-list',
        query: {
          selectMode: 'true',
          resourceRequestId: this.currentRequestForOrder.id,
          returnUrl: this.$route.fullPath
        }
      });
      this.orderDrawerVisible = false;
    },

    // 关联订单
    associateOrder(orderId) {
      const resourceId = this.currentRequestForOrder.id;
      const productsId = this.currentRequestForOrder.product_id || ''; // 假设存在product_id字段
      console.log(productsId)

      this.$axios.post('/api-30216/api/order-resources', {
        order_id: orderId,
        resource_id: resourceId,
        products_id: productsId
      }, {
        headers: { 'Content-Type': 'application/json' },
        transformRequest: [postData => JSON.stringify(postData)]
      }).then(response => {
        if (response.code === 200) {
          this.$message.success('订单关联成功');
          // 重新获取订单信息
          this.getCurrentOrderInfo(orderId);
        } else {
          this.$message.error(response.message || '订单关联失败');
        }
      }).catch(error => {
        console.error(error);
        this.$message.error('操作失败，请检查网络或服务状态');
      });
    },

    // 获取当前订单信息
    getCurrentOrderInfo(orderId) {
      // 当orderId为空时，保持currentOrder为空
      if (!orderId) {
        this.currentOrder = {
          id: '',
          order_no: '',
          customer_name: '',
          resource_type: '',
          order_type: '',
          billing_day: '',
          status: '',
          total_price: '',
          currency: '',
          dev_number: '',
          delivered_number: '',
          starting_time: '',
          end_time: '',
          price_items: []
        };
        return;
      }

      // 从API获取订单详情，与order-list的order-details使用相同的API路径
      this.$axios.get(`/api-30216/api/orders/${orderId}`, {
        // 禁用缓存，防止301重定向问题
        headers: {
          'Cache-Control': 'no-cache',
          'Pragma': 'no-cache',
          'Expires': '0'
        }
      })
        .then(response => {
          if (response.data) {
            this.currentOrder = {
              id: response.data.id,
              order_no: response.data.order_no || response.data.contract_name,
              customer_name: response.data.customer_name,
              resource_type: response.data.resource_type,
              order_type: response.data.order_type,
              billing_day: response.data.billing_day,
              status: response.data.status,
              total_price: response.data.total_price,
              currency: response.data.currency,
              dev_number: response.data.dev_number,
              delivered_number: response.data.delivered_number,
              starting_time: response.data.starting_time,
              end_time: response.data.end_time,
              region: response.data.region,
              price_items: response.data.price_items || []
            };
          } else {
            // 无订单数据，保持currentOrder为空
            this.currentOrder = {
              id: '',
              order_no: '',
              customer_name: '',
              resource_type: '',
              order_type: '',
              billing_day: '',
              status: '',
              total_price: '',
              currency: '',
              dev_number: '',
              delivered_number: '',
              starting_time: '',
              end_time: '',
              region: '',
              price_items: []
            };
          }
        })
        .catch(error => {
          console.error('获取订单详情失败:', error);
          // 出错时保持currentOrder为空
          this.currentOrder = {
            id: '',
            order_no: '',
            customer_name: '',
            resource_type: '',
            order_type: '',
            billing_day: '',
            status: '',
            total_price: '',
            currency: '',
            dev_number: '',
            delivered_number: '',
            starting_time: '',
            end_time: '',
            price_items: []
          };
        });
    },

    // 交付管理
    handleOrderDelivery() {
      // 检查合同状态是否为"生效中"
      if (this.currentOrder.status !== 2) {
        this.$message.warning('只有订单状态为"生效中"时才能发起交付');
        return;
      }
      // 跳转到交付管理页面
      this.$router.push({
        path: '/orderDelivery',
        query: {
          id: this.currentOrder.id
        }
      });
      this.orderDrawerVisible = false;
    },

    // 订单管理
    handleOrderManagement() {
      // 可以跳转到订单管理页面
      this.$router.push({
        path: '/api/order-list'
      });
      this.orderDrawerVisible = false;
    },

    // 回收管理
    handleOrderRecycle() {
      // 跳转到交付管理页面（回收功能已在该页面实现）
      this.$router.push({
        path: '/orderDelivery',
        query: {
          id: this.currentOrder.id
        }
      });
      this.orderDrawerVisible = false;
    },
    
    // 处理订单创建成功
    handleOrderSuccess() {
      // 刷新表格数据
      this.getTableData();
      
      // 检查是否有关联订单并更新订单信息
      if (this.currentRequestForOrder) {
        this.checkAssociatedOrder(this.currentRequestForOrder.id);
      }
    },
  }

}
</script>

<style scoped lang="scss">
.pagebody {
  margin-top: 20px;
  margin-left: 20px;
}
.filter-bar {
  margin-bottom: 10px;
}
.main-table {
  margin-top: 10px;
}

.search-button-line {
  display: flex;
  justify-content: flex-end;
}
.batch-button {
  min-width: 95px;
}

/* 订单管理抽屉样式 */
.order-buttons-bar {
  display: flex;
  gap: 10px;
  padding-bottom: 15px;
  margin: 0 20px 15px;
  border-bottom: 1px solid #ebeef5;
}

.no-order-state {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 300px;
  text-align: center;
}

.no-order-icon {
  font-size: 48px;
  color: #909399;
  margin-bottom: 20px;
}

.no-order-text {
  font-size: 16px;
  color: #606266;
  margin-bottom: 30px;
}

.no-order-actions {
  display: flex;
  gap: 10px;
}

.order-card {
  margin-bottom: 20px;
}

.order-info {
  margin-bottom: 20px;
}

.info-item {
  margin-bottom: 12px;
}

.info-label {
  display: inline-block;
  width: 100px;
  font-weight: 500;
  color: #606266;
}

.info-value {
  color: #303133;
}

.price-unit {
  font-size: 11px;
  color: #666;
}

.order-actions {
  margin-top: 20px;
  padding-top: 20px;
  border-top: 1px solid #ebeef5;
}

/* 订单详情样式 */
.detail-card {
  margin: 0;
}

.detail-item {
  display: flex;
  margin-bottom: 10px;
  min-height: 28px;
  align-items: center;
}

.detail-label {
  width: 120px;
  color: #606266;
  text-align: right;
  padding-right: 12px;
  font-size: 15px;
}

.detail-value {
  flex: 1;
  color: #303133;
}

.clearfix:before,
.clearfix:after {
  display: table;
  content: "";
}

.clearfix:after {
  clear: both;
}
.detail-title h3{
  width: 120px;
  font-weight: bold;
  color: #606266;
  text-align: left;
  padding-right: 12px;
  font-size: 16px;
}

/* 状态样式 */
.status-enabled {
  color: #67c23a;
}

.status-disabled {
  color: #909399;
}
</style>
